import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { Broadcaster } from '.../../environments/broadcaster';
import { AuthService } from '../../_services/index';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { LoaderService } from 'app/_services/loader.service';
import Swal from 'sweetalert2'

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;

declare var $: any;

@Component({
  selector: 'app-ecokra',
  templateUrl: './ecokra.component.html',
  styleUrls: ['./ecokra.component.scss']
})
export class EcokraComponent implements OnInit {

  showLoader: boolean;
  public data: any;
  selectedRow: Number;
  selectEmployeeMstrDetailsRow: Function;
  public prjId: any;
  kraData: any;
  kraList: any;
  public search: any;
  public showDialog: any;
  public userId: any;
  hasRecords: boolean = true;
  addressModel: any;
  vehtypModel: any;
  vehNoModel: any;
  wardModel: any;
  zoneModel: any;
  houseCountModel: any;
  helperNameModel: any;
  driverNameModel: any;
  helperNumModel: any;
  driverNumModel: any;
  defaulterModel: any;
  dTOdCollectionModel: any;
  imeiModel: any;
  vtsModel: any;
  isSubmmit: boolean = false;
  checkVehNo: boolean;
  checkVehTyp: any;
  checkZone: boolean;
  checkWard: boolean;
  checkDriverName: boolean;
  checkDriverNum: boolean;
  checkHelperName: boolean;
  checkHelperNum: boolean;
  checkAddress: boolean;
  saveSucc: boolean = false;
  saveFail: boolean = false;

  dataRangeModal: any;
  startDate: any;
  endDate: any;
  defaultStartDate: any;
  defaultEndDate: any;

  constructor(private http: HttpClient, private broadcaster: Broadcaster, private auth: AuthService, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.selectEmployeeMstrDetailsRow = function (data, index) {
      this.selectedRow = index;
      this.empId = data.ID;
    }

    var firstDay = new Date();
    var lastDay = new Date();
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defaultEndDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.dataRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() } };

  }
  ngOnInit() {
    this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.getAllKraDetails(this.startDate, this.endDate);
  }

  // get kra list and details
  getAllKraDetails(fromDate, toDate) {
    this.loaderService.display(true);
    this.http.get(environment.kraApi + 'kra?prjId=' + this.prjId + '&startDate=' + fromDate + '&endDate=' + toDate).subscribe((data) => {
      // debugger
      this.kraData = data;
      this.kraList = this.kraData.data;
      var getKra = this.kraList.kraList
      console.log("kra", getKra)
      this.loaderService.display(false);
      this.hasRecords = false
    });
  }

  onDateRangeChanged(dataRange) {
    if (this.startDate != '' || this.startDate != null || this.startDate != undefined) {
      var startDate = dataRange.beginDate.year + "-" + dataRange.beginDate.month + "-" + dataRange.beginDate.day
      var endDate = dataRange.endDate.year + "-" + dataRange.endDate.month + "-" + dataRange.endDate.day
      this.startDate = moment(startDate).format('YYYY-MM-DD');
      this.endDate = moment(endDate).format('YYYY-MM-DD');
      this.getAllKraDetails(this.startDate, this.endDate)
    }
    else {
      this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
      this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
      this.getAllKraDetails(this.startDate, this.endDate)
    }
  }

  // get kra list and details
  addKra() {
    this.loaderService.display(true);
    this.http.get(environment.kraApi + 'kra').subscribe((data) => {
      // debugger
      this.kraData = data;
      this.kraList = this.kraData.data;
      var getKra = this.kraList.kraList
      console.log("kra", getKra)
      this.loaderService.display(false);
      this.hasRecords = false
    });
  }

  addKraModelPop() {
    $("#AddModelPopup").modal("show");
  }

  onClickToSaveKra() {
    if (this.vehNoModel == null || this.vehNoModel == '' || this.vehNoModel == undefined) {
      this.checkVehNo = true;
      return;
    }
    if (this.vehtypModel == null || this.vehtypModel == undefined || this.vehtypModel == '') {
      this.checkVehTyp
      return;
    }
    if (this.zoneModel == null || this.zoneModel == undefined || this.zoneModel == '') {
      this.checkZone = true;
      return;
    }
    if (this.wardModel == null || this.wardModel == undefined || this.wardModel == '') {
      this.checkWard = true;
      return;
    }
    if (this.driverNameModel == null || this.driverNameModel == undefined || this.driverNameModel == '') {
      this.checkDriverName = true;
      return;
    }
    if (this.driverNumModel == null || this.driverNumModel == undefined || this.driverNumModel == '') {
      this.checkDriverNum = true;
      return;
    }
    if (this.helperNameModel == null || this.helperNameModel == undefined || this.helperNameModel == '') {
      this.checkHelperName = true;
      return;
    }
    if (this.helperNumModel == null || this.helperNumModel == undefined || this.helperNumModel == '') {
      this.checkHelperNum = true;
      return;
    }
    // if (this.addressModel == null || this.addressModel == undefined || this.addressModel == '') {
    //   this.checkAddress = true;
    //   return;
    // }

    this.isSubmmit = true; //disable the button after the submit button click
    // this.currentDate = new Date();
    this.loaderService.display(true);

    var kraObj = {
      "houseAddress": this.addressModel ? this.addressModel : "",
      "vehicleType": this.vehtypModel ? this.vehtypModel : "",
      "wardNo": this.wardModel ? this.wardModel : "",
      "noOfHouses": this.houseCountModel ? this.houseCountModel : "",
      "detailOfDefaulter": this.defaulterModel ? this.defaulterModel : "",
      "vehicleNo": this.vehNoModel ? this.vehNoModel : "",
      "doorCollection": this.dTOdCollectionModel ? this.dTOdCollectionModel : "",
      "helperName": this.helperNameModel ? this.helperNameModel : "",
      "driverName": this.driverNameModel ? this.driverNameModel : "",
      "imei": this.imeiModel ? this.imeiModel : "",
      "zoneName": this.zoneModel ? this.zoneModel : "",
      "vtsStatus": this.vtsModel ? this.vtsModel : "",
      "driverMobile": this.driverNumModel ? this.driverNumModel : "",
      "helperMobile": this.helperNumModel ? this.helperNumModel : "",
      "wardName": this.wardModel ? this.wardModel : ""
    }

    console.log("Obj", kraObj)

    this.http.post(environment.kraApi + 'kra', kraObj).subscribe((data) => {
      setTimeout(() => {
        this.clearKraDetails();
        this.saveSucc = true
      }, 2000);
    }, error => {
      this.clearKraDetails();
      this.saveFail = true
    });
    this.loaderService.display(false);
    this.getAllKraDetails(this.startDate, this.endDate);
    $("#AddModelPopup").modal("hide");
  }

  reload() {
    this.getAllKraDetails(this.startDate, this.endDate);
  }


  //This method is used to clear the control after saved the Employee data
  clearKraDetails() {
    this.addressModel = null;
    this.vehtypModel = null;
    this.vehNoModel = null;
    this.wardModel = null;
    this.zoneModel = null;
    this.houseCountModel = null;
    this.helperNameModel = null;
    this.helperNumModel = null;
    this.driverNameModel = null;
    this.driverNumModel = null;
    this.defaulterModel = null;
    this.dTOdCollectionModel = null;
    this.imeiModel = null;
    this.vtsModel = null;
  }

  public restrictNumericForVtsMobileNo(e) {
    let input;
    var inputlen;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }

  //import to excel
  importKRAExcelReport(kraList) {
    const ws_name = 'KRAlist';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(kraList);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, {
      bookType: 'xlsx', bookSST: true, type:
        'binary'
    });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'kra.xlsx');
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }
}


// WEBPACK FOOTER //
// ./src/app/reports/hr/ecokra.component.ts